// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__JB9gj","signatureButtonsRight":"ModalSign_signatureButtonsRight__3iGxe"};